// src/Callback/Callback.js

import React, { Component } from 'react';

class RootAdmin extends Component {
  render() {
    return (
      <div>You don't have permissions to view this page. Root Admins Only</div>
    );
  }
}

export default RootAdmin;
